import { render, staticRenderFns } from "./FileUploadUiComponent.vue?vue&type=template&id=6c7c4e57&"
import script from "./FileUploadUiComponent.vue?vue&type=script&lang=ts&"
export * from "./FileUploadUiComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
